/**
 * TrackRow Component
 * 
 * Single recipe row with left rail (metadata) and track layer (segments).
 */

import React from 'react';
import { RecipeWithTiming, ScheduledSegment } from '../../types/menuPlanning';
import { formatDuration } from '../../utils/scheduler';
import SegmentBlock from './SegmentBlock';
import '../../styles/menuPlanning.css';

interface TrackRowProps {
  recipe: RecipeWithTiming;
  segments: ScheduledSegment[];
  pixelsPerSecond: number;
  conflictSegmentIds: Set<string>;
  onSegmentDragStart?: (segment: ScheduledSegment) => void;
  onSegmentDrag?: (segment: ScheduledSegment, newStartSec: number) => void;
  onSegmentDragEnd?: (segment: ScheduledSegment, newStartSec: number) => void;
  onSegmentResize?: (segment: ScheduledSegment, newDurationSec: number) => void;
}

export const TrackRow: React.FC<TrackRowProps> = ({
  recipe,
  segments,
  pixelsPerSecond,
  conflictSegmentIds,
  onSegmentDragStart,
  onSegmentDrag,
  onSegmentDragEnd,
  onSegmentResize
}) => {
  const recipeSegments = segments.filter(s => s.recipeId === recipe.id);
  const thumbnailUrl = recipe.images && recipe.images.length > 0 
    ? recipe.images[0] 
    : '/4.png';

  return (
    <div className="track-row">
      <div className="track-rail">
        <img 
          src={thumbnailUrl} 
          alt={recipe.name}
          className="track-rail-image"
          onError={(e) => {
            (e.target as HTMLImageElement).src = '/4.png';
          }}
        />
        <div className="track-rail-name">
          {recipe.name}
        </div>
        <div className="track-rail-timing">
          Active: {formatDuration(recipe.activeTotalSec)}
        </div>
        <div className="track-rail-timing">
          Inactive: {formatDuration(recipe.inactiveTotalSec)}
        </div>
      </div>
      <div className="track-area">
        {recipeSegments.map((segment) => (
          <SegmentBlock
            key={segment.id}
            segment={segment}
            pixelsPerSecond={pixelsPerSecond}
            isConflict={conflictSegmentIds.has(segment.id)}
            onDragStart={onSegmentDragStart}
            onDrag={onSegmentDrag}
            onDragEnd={onSegmentDragEnd}
            onResize={onSegmentResize}
          />
        ))}
      </div>
    </div>
  );
};

export default TrackRow;


